import { render, staticRenderFns } from "./item_tpl.vue?vue&type=template&id=20c2ef34&scoped=true"
import script from "./item_tpl.vue?vue&type=script&lang=js"
export * from "./item_tpl.vue?vue&type=script&lang=js"
import style0 from "./item_tpl.vue?vue&type=style&index=0&id=20c2ef34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c2ef34",
  null
  
)

export default component.exports